import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as symbols from '../../operations/symbols';
import { getOrders, sendEvent } from '../../actions/ordersAction';
import { fetchAppConfig } from './../../actions/appConfigActions';
import CommonHeaderComponent from '../headers/CommonHeaderComponent';
import OrderCardComponent from './OrderCardComponent';
import StateFilterComponent from '../core/StateFilterComponent';
import PictureModeModal from '../core/PictureModeModal';
import ReasonListModal from '../core/ReasonListModal';
import LoaderComponent from '../core/LoaderComponent';
import Search from "sushiweb/Icons/all/Search";
import './orders.scss';
import { ORDER_STATUS, STATUS_VALUE } from "./../../operations/constants";

class OrdersComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openPictureModeModal: false,
      filterId: null,
      searchVal: '',
      selectedId: null,
      openReasonListModal: false,
      selectedOrder: null,
      filteredOrders: [],
      isFilterApplied: false
    }
  }

  componentDidMount() {
    const params = {
      daNumber: this.props.user.phone
    }
    this.props.actions.getOrders(params);
    this.props.actions.fetchAppConfig();
  }

  openPictureModeModal(id) {
    this.setState({
      openPictureModeModal: true,
      selectedId: id
    })
  }

  closePictureModeModal() {
    this.setState({ openPictureModeModal: false })
  }

  setSearchVal = (e) => {
    this.setState({ searchVal: e.target.value })
  }

  handleSearchFilter(e, filterId) {
    e.preventDefault();
    const { orders } = this.props;
    let filteredOrders = [];
    switch (filterId) {
      case 4:
        filteredOrders = orders.filter(order => {
          return order.status === ORDER_STATUS.pending;
        })
        break;
      case 5:
        filteredOrders = orders.filter(order => {
          return order.status === ORDER_STATUS.cancelled || order.status === ORDER_STATUS.delivered;
        })
        break;
      case 6:
        filteredOrders = orders.filter(order => {
          return order.status === ORDER_STATUS.reattempt;
        })
        break;
      default:
        break;
    }
    this.setState({ filteredOrders: filteredOrders, isFilterApplied: true });
    return false
  }

  clearFilter = (e) => {
    e.stopPropagation();
    this.setState({ filterId: null, isFilterApplied: false });
  }

  handleFilterChange(e, filterId) {
    this.handleSearchFilter(e, filterId);
    this.setState({filterId: filterId});
  }

  openReasonListModal(id, order) {
    this.setState({ openReasonListModal: true, selectedId: id, selectedOrder: order })
  }

  closeReasonListModal(id) {
    this.setState({ openReasonListModal: false, selectedOrder: null })
  }

  handleSearch = (e) => {
    e.preventDefault();
    let params = {
      orderNumber: this.state.searchVal,
      daNumber: this.props.user.phone
    }
    this.props.actions.getOrders(params);
  }

  render() {

    const { openPictureModeModal, openReasonListModal, isFilterApplied, filteredOrders, filterId } = this.state;
    const { getOrdersStatus, orders } = this.props;
    const ordersToDisplay = isFilterApplied ? filteredOrders : orders;
    
    const orderStatusToOrdersMap = ordersToDisplay.reduce((combined, currentOrder) => {
      if (combined[currentOrder.status]) {
        combined[currentOrder.status].push(currentOrder)
      } else {
        combined[currentOrder.status] = [currentOrder]
      }
      return combined;
    }, {});

    // sort each orders array in map, by sequence no
    for (const key of Object.keys(orderStatusToOrdersMap)) {
      orderStatusToOrdersMap[key].sort((orderA, orderB) => {
        if (orderA.sequenceNumber < orderB.sequenceNumber) {
          return -1;
        } else if (orderA.sequenceNumber > orderB.sequenceNumber) {
          return 1;
        } else {
          return 0;
        }
      })
    }

    const sortedOrders = Object
      .entries(orderStatusToOrdersMap)
      .sort((entryA, entryB) => {
        // sort by keeping pending on top, then reattempt, then delivered, and then cancelled
        // sort map by key of the map i.e. order status
        const a_value = STATUS_VALUE[entryA[0]];
        const b_value = STATUS_VALUE[entryB[0]];
        if (a_value < b_value) {
          return -1;
        } else if (a_value > b_value) {
          return 1;
        } else {
          return 0;
        }
      })
      .reduce((combined, currentEntry) => {
        return [...combined, ...currentEntry[1]];
      }, []);

    return (
      <div className="hp-container gray-wrap pd-top-global">
        <PictureModeModal
          isOpen={openPictureModeModal}
          closePictureModeModal={() => this.closePictureModeModal()}
          id={this.state.selectedId}
        />
        <ReasonListModal
          isOpen={openReasonListModal}
          closeReasonListModal={() => this.closeReasonListModal()}
          id={this.state.selectedId}
          selectedOrder={this.state.selectedOrder}
        />
        <CommonHeaderComponent
          title={orders && orders.length == 0 ? 'Orders' : 'Route'}
          routeId={orders && orders.length > 0 && orders[0].route}
        />
        <div className="order-top-header">
          <form className="no-style" onSubmit={(e) => this.handleSearch(e)}>
            <div className="input-field-wrap">
              <input
                type="text"
                className="input-field__input search-input"
                placeholder="Search order number"
                onChange={this.setSearchVal}
              />
              <button type="submit" className="search-icon">
                <Search className="icon-color-gray icon-fs-15" />
              </button>
            </div>
          </form>
          <StateFilterComponent
            filterId={this.state.filterId}
            handleFilterChange={(e, id, value) => this.handleFilterChange(e, id, value)}
            clearFilter={this.clearFilter}
          />
        </div>
        {
          getOrdersStatus == symbols.STATUS_BEGIN ?
            <LoaderComponent />
            :
            <React.Fragment>

              {
                sortedOrders.length > 0 ?
                  <React.Fragment>
                    {sortedOrders.map((ele, index) => {
                      return (
                        <OrderCardComponent
                          order={ele}
                          openReasonListModal={(id, ele) => this.openReasonListModal(id, ele)}
                          openPictureModeModal={(id) => this.openPictureModeModal(id)}
                          key={index}
                        />
                      )
                    })
                    }
                  </React.Fragment> :
                  <div className="black-text order-top-header mt-2">No Results Found</div>
              }
            </React.Fragment>
        }
      </div>
    )
  }
}

const actions = { getOrders, sendEvent, fetchAppConfig }
export default connect(
  state => ({
    getOrdersStatus: state.statuses.getOrders.status,
    getOrdersError: state.statuses.getOrders.error,
    orders: state.orders.orders || [],
    user: state.auth.user
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(OrdersComponent);
